<template>
  <Row type="flex" justify="space-around" align="middle" style="margin-bottom: 64px">
    <Col span="24">
      <Hero
        title="Vue Finance - Pricing"
        minHeight="500px"
        backgroundColor="#2c3849"
        description="We’ll deliver the critical reports and insights needed to grow your net worth, whether you’re an everyday investor or a single family office."></Hero>

      <Row type="flex" justify="center" class="section">
        <Col class="info-section-col">
          <h2>Features Included in All Plans</h2>
          <h3><Icon class="green" type="checkmark-round"></Icon><span class=""> Access to 14,000+ Integrations </span></h3>
          <h3><Icon class="green" type="checkmark-round"></Icon><span class=""> Custom Assessments and Reporting </span></h3>
          <h3><Icon class="green" type="checkmark-round"></Icon><span class=""> Custom Asset Valuations </span></h3>
          <h3><Icon class="green" type="checkmark-round"></Icon><span class=""> Custom Portfolio Values and KPIs </span></h3>
          <h3><Icon class="green" type="checkmark-round"></Icon><span class=""> Nested Accounts </span></h3>

          <router-link :to="{ name: 'Features' }">
            <Button type="text" class="primary">See All Features <Icon type="arrow-right-c"></Icon></Button>
          </router-link>
        </Col>

        <Col class="info-section-col">
          <h2>Frequently Asked Questions</h2>
            <Row v-for="(item, $index) in faqs" :key="$index">
              <Poptip
                placement="bottom"
                :title="item.question"
                :content="item.answers.join(' ')">
                <a><h3><Icon type="information-circled"></Icon> {{ item.question }}</h3></a>
              </Poptip>
            </Row>
        </Col>
      </Row>

      <Row type="flex" justify="center" align="middle" class="section">
        <h2 style="text-align: center; font-size: 1.6rem"> <Icon class="green" style="font-size: 1.6rem; padding: 8px;" type="arrow-right-c"></Icon><span class="underline">14-Day free trial</span> for all plans. <span class="underline">Cancel any time</span>.</h2>
      </Row>

      <Row type="flex" justify="center" align="middle" class="section">
        <PricingPlanCard
          v-for="(plan, $index) in pricingPlans"
          @show-annual-toggle="showAnnual = !showAnnual"
          buttonType="primary"
          :plan="plan"
          :key="$index"
          :showAnnual="showAnnual">
        </PricingPlanCard>
      </Row>

      <Row type="flex" justify="center">
        <Col style="margin: 0 32px; width: 750px">
          
          <Card>
            <Row type="flex" justify="center" style="margin-bottom: 8px; padding: 0 0px">
              <h2>Enterprise Pricing</h2>
              <p style="text-align: center;">For family offices, wealth managers, estate managers, and other enterprises needing high-performing software to fit all of your company’s reporting and management needs.</p>
            </Row>
            <Row type="flex" justify="center">
              <ScheduleButton type="primary" title="Schedule Demo" eventType="demo" :isMobile="isMobile" style="margin: 4px 4px;"></ScheduleButton>
              <ScheduleButton type="default" title="Schedule a Call" eventType="introductory-call" :isMobile="isMobile" style="margin: 4px 4px;"></ScheduleButton>
            </Row>
          </Card>
        </Col>
      </Row>

<!--       <Row type="flex" justify="center">
        <Col style="margin: 0 32px; width: 650px">
          
          <Card>
            <Row type="flex" justify="center" style="margin-bottom: 8px;">
              <h2>Need a Custom Plan?</h2>
            </Row>
            <Row type="flex" justify="center">
              <ScheduleButton title="Schedule a Call" eventType="introductory-call" :isMobile="isMobile"></ScheduleButton>
            </Row>
          </Card>
        </Col>
      </Row> -->

<!--       <Row type="flex" justify="center" align="middle" style="margin: 20px 0;" class="section">
        <i-switch v-model="showAnnual"></i-switch>
        <h2 style="padding-left: 8px;">Pay Annually. Get 1 Month Free.</h2>
      </Row> -->
    </Col>
  </Row>
</template>
<script>
import PricingPlanCard from './PricingPlanCard';
import Hero from './Hero';
import pricingFAQs from '../services/faqs';
import pricingPlans from '../services/pricingPlans';
import ScheduleButton from './ScheduleButton';

export default {
  props: ['isMobile'],
  components: { PricingPlanCard, Hero, ScheduleButton },
  data() {
    return {
      showAnnual: true,
      faqs: pricingFAQs,
      pricingPlans,
    };
  },
};
</script>
<style lang="css" scoped>
.underline {
  text-decoration: underline;
}

h2 {
  font-size: 1.5rem;
}

.section {
  padding: 16px;
  /*color: #fff;*/
}

.ivu-switch-checked {
  border-color: #00cc66;
  background-color: #00cc66;
}

.info-section-col {
  /*padding: 8px 8px;*/
  padding: 16px 42px;
}
</style>


// WEBPACK FOOTER //
// src/components/PricingPage.vue